import { memo } from "react";
import { Navbar } from "./navbar";
import * as page from "./page.module.css";

export const Page = memo(({ children }: { children: React.ReactElement }) => {
  return (
    <div className={page.pageWrapper}>
      <Navbar className={page.navBar} />
      {children}
    </div>
  );
});
